import request from '@/utils/request'
const BASE_URL = '/Attachment'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  upload: BASE_URL + "/Upload",
  noticeUpload: BASE_URL + "/NoticeUpload",
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
}